"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpcomingBooking = exports.isBookingWithin24Hours = exports.getReservedBookingsWithin48Hours = exports.getEventTypeForClinician = exports.getClinicianFutureBookings = exports.formatRecurringRule = exports.formatRecurringInstance = exports.formatRecurringFrequencyPrefix = exports.formatRecurringFrequency = exports.didClinicianAndPatientAttendBooking = exports.categorizeBookings = exports.canUpdateAppointment = exports.SINGLE_TIME_FORMAT = exports.RECURRING_TIME_START_FORMAT = exports.PastBookingStatus = exports.JoinCallGracePeriodMinutes = exports.BookingStatusText = exports.BookingEventTypeDuration = exports.AttendanceStatus = exports.AppointmentsUtils = exports.ActiveBookingStatuses = void 0;
exports.mapSlotToMoments = mapSlotToMoments;
exports.showValueWithAutoRescheduledTooltip = exports.showRescheduledTooltipText = exports.recurringRuleToScheduleLine = exports.needToExtendBooking = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _ = require("./");
var _types = require("../types");
var _components = require("../components");
var _excluded = ["start", "end"];
var _BookingStatusText, _BookingEventTypeDura;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StatusFilter = {
  Active: 'active',
  Archive: 'archive',
  All: 'all'
};
var ActiveBookingStatuses = [_types.BookingStatus.Reservation, _types.BookingStatus.Scheduled];
exports.ActiveBookingStatuses = ActiveBookingStatuses;
var BookingStatusText = (_BookingStatusText = {}, _defineProperty(_BookingStatusText, _types.BookingStatus.Canceled, 'Canceled'), _defineProperty(_BookingStatusText, _types.BookingStatus.Scheduled, 'Scheduled'), _defineProperty(_BookingStatusText, _types.BookingStatus.Completed, 'Completed'), _defineProperty(_BookingStatusText, _types.BookingStatus.Reservation, 'Reservation'), _BookingStatusText);
exports.BookingStatusText = BookingStatusText;
var AttendanceStatus = {
  PatientAttend: 'patient-attend',
  PatientLate: 'patient-late',
  PatientMiss: 'patient-miss',
  ClinicianAttend: 'clinician-attend',
  ClinicianLate: 'clinician-late',
  ClinicianMiss: 'clinician-miss'
};

// In minutes
exports.AttendanceStatus = AttendanceStatus;
var BookingEventTypeDuration = (_BookingEventTypeDura = {}, _defineProperty(_BookingEventTypeDura, _types.BookingEventType.PhysicianCheckin, 15), _defineProperty(_BookingEventTypeDura, _types.BookingEventType.TherapyCall, 60), _BookingEventTypeDura);
exports.BookingEventTypeDuration = BookingEventTypeDuration;
var PastBookingStatus = /*#__PURE__*/function (PastBookingStatus) {
  PastBookingStatus["All"] = "all";
  PastBookingStatus["Canceled"] = "canceled";
  PastBookingStatus["Missed"] = "missed";
  PastBookingStatus["Attended"] = "attended";
  return PastBookingStatus;
}({});
exports.PastBookingStatus = PastBookingStatus;
var JoinCallGracePeriodMinutes = {
  before: 15,
  after: 6 * 60 // 6 hours
};
exports.JoinCallGracePeriodMinutes = JoinCallGracePeriodMinutes;
var PROVIDER_BOOKING_UPDATE_GRACE_PERIOD_MINUTES = 15;

/**
 * Used to derive `start` strings when converting recurring times
 * to different timezones
 */
var RECURRING_TIME_START_FORMAT = 'HH:mm';
exports.RECURRING_TIME_START_FORMAT = RECURRING_TIME_START_FORMAT;
var RECURRING_TIME_FORMAT = 'dddd [at] h:mma z';
// TODO: Maybe standardize this across codebase in some way
var SINGLE_TIME_FORMAT = 'dddd, MMMM D, h:mma z';
exports.SINGLE_TIME_FORMAT = SINGLE_TIME_FORMAT;
var formatDate = function formatDate(date) {
  return (0, _momentTimezone.default)(date).format('ddd, MMM D, YYYY');
};

/**
 * @returns Ex. "4:00-4:45pm, EDT"
 */
var formatTimeSpan = function formatTimeSpan(_ref) {
  var startsAt = _ref.startsAt,
    duration = _ref.duration;
  return (0, _momentTimezone.default)(startsAt).format('h:mm') + '-' + (0, _momentTimezone.default)(startsAt).add({
    minutes: duration
  }).format('h:mma, z');
};

/**
 * @param rule Recurring rule entity
 * @returns Ex. "Friday, 4:00pm, EDT"
 */
var formatRecurringRule = function formatRecurringRule(rule) {
  return _momentTimezone.default.tz("".concat(rule.day, " ").concat(rule.start), "dddd ".concat(RECURRING_TIME_START_FORMAT), rule.timeZone).format(RECURRING_TIME_FORMAT);
};

/**
 * @param instance A moment object representing one instance of a recurring rule
 * @returns Ex. "Friday, 4:00pm, EDT"
 */
exports.formatRecurringRule = formatRecurringRule;
var formatRecurringInstance = function formatRecurringInstance(instance) {
  return instance.format(RECURRING_TIME_FORMAT);
};
exports.formatRecurringInstance = formatRecurringInstance;
var formatRecurringFrequency = function formatRecurringFrequency(intervalFrequency) {
  return intervalFrequency === 2 ? 'biweekly' : 'weekly';
};
exports.formatRecurringFrequency = formatRecurringFrequency;
var formatRecurringFrequencyPrefix = function formatRecurringFrequencyPrefix(intervalFrequency) {
  return intervalFrequency === 2 ? 'every other' : 'every';
};
exports.formatRecurringFrequencyPrefix = formatRecurringFrequencyPrefix;
var canUpdateAppointment = function canUpdateAppointment(booking) {
  var provider = booking.provider,
    status = booking.status,
    startsAt = booking.startsAt;
  return provider === _types.BookingProvider.Cronofy && ActiveBookingStatuses.includes(status) && (0, _momentTimezone.default)().isBefore((0, _momentTimezone.default)(startsAt).add(PROVIDER_BOOKING_UPDATE_GRACE_PERIOD_MINUTES, 'minutes'));
};

/**
 *
 * @param {object} params
 * @param {object} params.booking
 * @param {boolean} params.includeGracePeriod Whether to add a grace period to the
 * end time of a booking. Primarily used to allow members to join video calls.
 */
exports.canUpdateAppointment = canUpdateAppointment;
var isUpcomingBooking = function isUpcomingBooking(_ref2) {
  var booking = _ref2.booking,
    includeGracePeriod = _ref2.includeGracePeriod;
  var now = (0, _momentTimezone.default)();
  var endsAt = (0, _momentTimezone.default)(booking.startsAt).add(booking.duration, 'minutes').add(includeGracePeriod ? JoinCallGracePeriodMinutes.after : 0, 'minutes');
  return now.isBefore(endsAt) && booking.status !== _types.BookingStatus.Canceled;
};
exports.isUpcomingBooking = isUpcomingBooking;
var getEventTypeForClinician = function getEventTypeForClinician(clinician) {
  if (!clinician) {
    return;
  }
  return (0, _.isPhysician)(clinician) ? _types.BookingEventType.PhysicianCheckin : _types.BookingEventType.TherapyCall;
};
exports.getEventTypeForClinician = getEventTypeForClinician;
var showRescheduledTooltipText = function showRescheduledTooltipText(startsAt) {
  return startsAt && "This booking was automatically rescheduled from its original recurring time slot of ".concat((0, _momentTimezone.default)(startsAt).format('ddd, MMM D, YYYY h:mma, z'), " because the time was not available on the clinician's calendar");
};
exports.showRescheduledTooltipText = showRescheduledTooltipText;
var showValueWithAutoRescheduledTooltip = function showValueWithAutoRescheduledTooltip(value, showIcon, startsAt) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-row align items-start justify-start"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pr-[8px]"
  }, value), showIcon && startsAt && /*#__PURE__*/_react.default.createElement(_components.Tooltip, {
    title: showRescheduledTooltipText(startsAt),
    className: "cursor-pointer relative right-0"
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "info-filled",
    className: "min-w-[16px] max-w-16px",
    size: 16
  })));
};
exports.showValueWithAutoRescheduledTooltip = showValueWithAutoRescheduledTooltip;
var didClinicianAndPatientAttendBooking = function didClinicianAndPatientAttendBooking(booking) {
  return booking.completedOffPlatform || booking.totalConnected > 0;
};
exports.didClinicianAndPatientAttendBooking = didClinicianAndPatientAttendBooking;
var recurringRuleToScheduleLine = function recurringRuleToScheduleLine(recurringRule, user) {
  if (!recurringRule) {
    return 'This patient does not have a recurring schedule';
  }
  var dayFormat = 'dddd';
  var timeFormat = 'h:mm a z';
  var resultLine = (0, _lodash.capitalize)(formatRecurringFrequencyPrefix(recurringRule.intervalFrequency));

  // Clinician get time in own time zome, all the others - original recurring rule time zone
  if ((0, _.isClinician)(user)) {
    resultLine += " ".concat((0, _momentTimezone.default)(recurringRule.anchorDate).format(dayFormat), " at ").concat((0, _momentTimezone.default)(recurringRule.anchorDate).format(timeFormat));
  } else {
    resultLine += " ".concat((0, _momentTimezone.default)(recurringRule.anchorDate).tz(recurringRule.timeZone).format(dayFormat), " at ").concat((0, _momentTimezone.default)(recurringRule.anchorDate).tz(recurringRule.timeZone).format(timeFormat));
  }
  return resultLine;
};
exports.recurringRuleToScheduleLine = recurringRuleToScheduleLine;
var getClinicianFutureBookings = function getClinicianFutureBookings(clinician) {
  var bookings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (0, _lodash.sortBy)(categorizeBookings(bookings).futureBookings.filter(function (booking) {
    return booking.clinicianId === clinician.id;
  }), ['startsAt']);
};
exports.getClinicianFutureBookings = getClinicianFutureBookings;
function mapSlotToMoments(slot) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var start = slot.start,
    end = slot.end,
    other = _objectWithoutProperties(slot, _excluded);
  return _objectSpread(_objectSpread({
    start: (0, _momentTimezone.default)(start),
    end: (0, _momentTimezone.default)(end)
  }, other), extra);
}
var categorizeBookings = function categorizeBookings() {
  var bookings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var now = (0, _momentTimezone.default)();
  // Bookings are still considered "present" up 6 hours after end time
  var presentAndFutureBookings = bookings.filter(function (booking) {
    return isUpcomingBooking({
      booking: booking,
      includeGracePeriod: true
    });
  });
  var paidBookings = presentAndFutureBookings.filter(function (b) {
    return [_types.BookingStatus.Scheduled, _types.BookingStatus.Completed].includes(b.status);
  });
  // Bookings are joinable between 15 mins before start time and 6 hours after end time
  var _partition = (0, _lodash.partition)(paidBookings, function (b) {
      return (0, _.isBookingJoinable)(b);
    }),
    _partition2 = _slicedToArray(_partition, 2),
    joinableBookings = _partition2[0],
    upcomingBookings = _partition2[1];
  var futureBookings = presentAndFutureBookings.filter(function (b) {
    return (0, _momentTimezone.default)(b.startsAt).isAfter(now);
  });
  var reservedBookings = futureBookings.filter(function (b) {
    return b.status === _types.BookingStatus.Reservation;
  });
  return {
    reservedBookings: reservedBookings,
    futureBookings: futureBookings,
    joinableBookings: joinableBookings,
    upcomingBookings: upcomingBookings
  };
};
exports.categorizeBookings = categorizeBookings;
var isBookingWithin24Hours = function isBookingWithin24Hours(booking) {
  return (0, _momentTimezone.default)(booking.startsAt).isBefore((0, _momentTimezone.default)().add(24, 'hours'));
};
exports.isBookingWithin24Hours = isBookingWithin24Hours;
var getReservedBookingsWithin48Hours = function getReservedBookingsWithin48Hours(bookings) {
  if (!bookings) {
    return [];
  }
  var _categorizeBookings = categorizeBookings(bookings),
    reservedBookings = _categorizeBookings.reservedBookings;
  return reservedBookings.filter(function (booking) {
    return (0, _momentTimezone.default)(booking.startsAt).isBefore((0, _momentTimezone.default)().add(48, 'hours'));
  });
};
exports.getReservedBookingsWithin48Hours = getReservedBookingsWithin48Hours;
var needToExtendBooking = function needToExtendBooking(booking) {
  return (0, _.isTherapist)(booking.clinician) && ActiveBookingStatuses.includes(booking.status) && booking.duration !== BookingEventTypeDuration[_types.BookingEventType.TherapyCall];
};

// TODO: export each member individually instead of
// destructuring from object
exports.needToExtendBooking = needToExtendBooking;
var AppointmentsUtils = {
  StatusFilter: StatusFilter,
  formatDate: formatDate,
  formatTimeSpan: formatTimeSpan,
  formatRecurringFrequency: formatRecurringFrequency
};
exports.AppointmentsUtils = AppointmentsUtils;